import { moment } from '@eb/date';

// TODO: Do we still need this?
// reexport from js-utils to avoid breaking contract
export { FULL_TIME_FORMAT } from '@eb/datetime';
export const TIME_PARAM_FORMAT = 'HH:mm';

const START_OF_DAY = '00:00';
const END_OF_DAY = '23:59';
const DEFAULT_STEP = 30;
const LOCALIZED_TIME_FORMAT = 'LT';

/**
 * @param {string} [minTime='00:00'] - minimum time in the list. Must be ISO 8601 format for time.
 * @param {string} [maxTime='23:59'] - maximum time in the list. Must be ISO 8601 format for time.
 * @returns {string[]} List of times from minimum time to maximum time inclusive.
 */
export const getListOfTimes = (
    minTime = START_OF_DAY,
    maxTime = END_OF_DAY,
) => {
    const timeList = [];

    const momentForManipulation = moment(minTime, TIME_PARAM_FORMAT, true);
    const maxTimeMoment = moment(maxTime, TIME_PARAM_FORMAT, true);

    if (!momentForManipulation.isValid()) {
        throw new Error('minTime must be in HH:mm format');
    }

    if (!maxTimeMoment.isValid()) {
        throw new Error('maxTime must be in HH:mm format');
    }

    //This is necessary to avoid date errors.
    maxTimeMoment.set({
        year: momentForManipulation.year(),
        month: momentForManipulation.month(),
        date: momentForManipulation.date(),
    });

    if (
        maxTimeMoment.isSame(momentForManipulation) ||
        maxTimeMoment.isBefore(momentForManipulation)
    ) {
        throw new Error('maxTime must be after the minTime');
    }

    while (
        momentForManipulation.isSame(maxTimeMoment) ||
        momentForManipulation.isBefore(maxTimeMoment)
    ) {
        timeList.push(momentForManipulation.format(LOCALIZED_TIME_FORMAT));
        momentForManipulation.add(DEFAULT_STEP, 'minutes');
    }

    return timeList;
};

/**
 * Takes an integer and adds a zero to the beginning for single digits;
 * double digits returned with no modification.
 *
 * @param  {Number} number number to pad
 * @return {String} padded number e.g. 14 or 05
 */
const _zeroPad = (number) => `0${number}`.slice(-2);

/**
 * Formats time given a duration in seconds. Returns "minutes:seconds" with unpadded minutes and padded seconds
 * (e.g. 7:05 instead of 07:05 or 7:5) for durations less than an hour, or "hours:minutes:seconds" with unpadded
 * hours, padded minutes, and padded seconds for durations over an hour (e.g. 1:08:29)
 *
 * Note: We don't currently have a use case for handling durations 24 hours and up, but this can be easily modified
 * to do so with duration.days()
 *
 * @param  {Number} durationInSeconds Duration in seconds
 * @return {String} formattedTime
 */
export const formatDuration = (durationInSeconds) => {
    const duration = moment.duration(durationInSeconds, 'seconds');
    const paddedSeconds = _zeroPad(duration.seconds());

    if (duration.hours() > 0) {
        const paddedMinutes = _zeroPad(duration.minutes());

        return `${duration.hours()}:${paddedMinutes}:${paddedSeconds}`;
    }

    return `${duration.minutes()}:${paddedSeconds}`;
};
